/* eslint-disable import/prefer-default-export */
import { formValueSelector } from 'redux-form';
import { TRAVEL_DOCUMENT_NUMBER } from './constants';
import getTravelerFormSectionName from './travelerFormName';
export const getSelected = form => (state, id) => formValueSelector(form)(state, getTravelerFormSectionName(id, TRAVEL_DOCUMENT_NUMBER)) || null;